// extracted by mini-css-extract-plugin
export default {"star-icon":"_hwkg6k","starIcon":"_hwkg6k","rating":"_1t1e8qt"};